import moment from 'moment';
import { getAdvancedSearchShipments } from '../api';
import { getShipmentsSuccess, getShipmentsFailure } from '../../../store/shipments/shipments.actions';
import { id as fulfillmentTypeId } from '../../../filters/options/fulfillment-type';
import { shipments } from '../../../filters/options/fulfillment-type/options';
import { id as shipDateId } from '../../../filters/options/ship-date';
import Global from '../../../store/global-selectors';
import { ColumnOrderByParamService } from '../../../services/column-orderby-param-service';
import { ADVANCED_SEARCH_ID } from '../../../pages/orders-page/orders-page-view-constants';

export default {
  filterBuilder: undefined, // Advanced Search filters are entirely context-driven now.
  apiCall: getAdvancedSearchShipments,
  baseUrl: '',
  successActions: [getShipmentsSuccess],
  failureAction: getShipmentsFailure,
  convertResponse: (response) => response,
  getOrderBy: (reduxState) => {
    const { filterViewId } = Global.selectShipmentsFilteringActiveFilterView(reduxState);
    const orderBy = Global.selectShipmentsGridCurrentOrderByColumn(reduxState, {
      statusViewId: ADVANCED_SEARCH_ID,
      activeFilterViewId: filterViewId,
    });
    const orderByParam = ColumnOrderByParamService.getShippingGridOrderByApiParamOrDefault(orderBy, true);

    return {
      orderBy: orderByParam.orderBy,
      orderByDirection: orderByParam.orderByDirection,
    };
  },
  initialFilters: [
    {
      id: fulfillmentTypeId,
      value: shipments.apiKey,
    },
    {
      id: shipDateId,
      value: {
        from: moment().add(-90, 'days'),
      },
    },
  ],
};
